import { isUndNullEmpNew } from '../../helpers/UtilsHelper';

export class RoleClass {
    constructor(
        id = '',
        description = '',
        created = '',
        userId = '',
    ) {
        this.id = id;
        this.description = description;
        this.created = created;
        this.userId = userId;
    }

    static getClassName = () => {
        return 'Role - class';
    }

    static getClass = (obj = Object) => {
        if (!isUndNullEmpNew({ data: obj, subMethod: this.getClassName(), })?.result) {
            return new RoleClass(
                obj?.id,
                obj?.description,
                obj?.created,
                obj?.userId,
            );
        }

        return new RoleClass();
    }
}